import axios from 'axios'
import { notificationSuccess } from '../../../utils/customToastify'
import { contactLoading, getContactDataFromOldCrm, getContactsDivisions } from '../../Contacts/redux/ContactActions'
import {
  GET_ALL_CONTACTS,
  GET_CONTACT,
  GET_DUPLICATED_CONTACTS,
  RESET_CONTACT,
  RESET_DUPLICATED_CONTACTS,
} from '../../Contacts/redux/types'

export const getAccounts = (options, myFilters) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/accounts', {
      params: { ...options, myFilters },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getRfpProspects = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/rfp', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getMexicoFreights = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/mfp', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getZoomInfoLeads = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/zoominfo-leads', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getCadenceLeads = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/cadence-leads', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getImportInfoLeads = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/importinfo-leads', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getProspects = (options, myFilters) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/prospects', {
      params: { ...options, myFilters },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getVerifiedLeads = (options, myFilters) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/verified-leads', {
      params: { ...options, myFilters },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getLeads = (options, myFilters) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/leads', {
      params: { ...options, myFilters },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getDeadCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/dead', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getIGiveUpCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/i-give-up', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getNotQualifiedCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/not-qualified', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getUnassignedLeadsCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/unassigned-leads', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getToReassignCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/to-reassign', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const winAgainProspects = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/win-again-prospects', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const winAgainAccounts = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/win-again-acounts', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getDivisionClaimedLeads = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/division-claimed-leads', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getPendingAccounts = (options, myFilters) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/pending-accounts', {
      params: { ...options, myFilters },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getUnassignedProsepctsCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/unassigned-prospects', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getManagersBucketCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/managers-bucket', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getAllCustomers = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/all', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getCustomer = (contactId, divisionId) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get(`/customers-logistic/${contactId}`, { params: { divisionId } })
    dispatch({ type: GET_CONTACT, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const createCustomer = (data) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.post('/customers-logistic', data)
    notificationSuccess('Customer successfully created.')
    if (response.data?.id) {
      window.open(`/customer-logistics/${response.data.id}`, '_blank')
    }
  } finally {
    dispatch(contactLoading(false))
  }
}

export const updateCustomerLogistics = (contactId, divisionId, data) => async (dispatch) => {
  try {
    delete data.contactDivisionData
    delete data.creator
    delete data.stateData
    delete data.lesseeData
    delete data.cps
    delete data.funding
    delete data.smartboard
    delete data.lease
    delete data.truckRental
    delete data.truckSales
    delete data.finance
    delete data.insurance
    delete data.customerLogistic
    delete data.legalMsg

    dispatch(contactLoading(true))
    const response = await axios.patch(`/customers-logistic/${contactId}`, data)

    await dispatch(getCustomer(contactId, divisionId))
    dispatch(getContactDataFromOldCrm(contactId))
    dispatch(getContactsDivisions(contactId))
    notificationSuccess('Customer successfully updated.')
    dispatch({ type: GET_CONTACT, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const deleteCustomers = (ids, callback) => async () => {
  await axios.delete('/customers-logistic/multiple', { params: { ids } })
  if (typeof callback === 'function') {
    callback()
  }
}

export const resetCustomer = () => (dispatch) => {
  dispatch({
    type: RESET_CONTACT,
    payload: {},
  })
}

export const getDuplicatedCustomers = (options) => async (dispatch) => {
  try {
    dispatch({ type: RESET_DUPLICATED_CONTACTS })

    const res = await axios.get(`/customers-logistic/get-duplicates`, { params: { ...options } })

    dispatch({ type: GET_DUPLICATED_CONTACTS, payload: res.data })

    return res.data
  } catch (error) {
    //
  }
}

export const getCreditAppFreights = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/credit-app-freights', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getOnlineFormFreights = (options) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get('/customers-logistic/online-form-freights', {
      params: { ...options },
    })
    dispatch({ type: GET_ALL_CONTACTS, payload: response.data })
  } finally {
    dispatch(contactLoading(false))
  }
}
